const Loading = ({ msg }) => {
  return (
    <div className="loading-container">
      <div className="spinner-container">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  );
};
export default Loading;
